export default __webpack_public_path__ + "static/media/yellow-dot.d1944f2a.svg";